import React from "react";
import { thisBaseURL } from "../../utils/helper.js";

function StandardsGrades({foodAnswers}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let codexStdSourceRef = foodAnswers.answerKeyValues['codex_standard_number_sources'];
	let codexStdNotes = foodAnswers.answerKeyValues['codex_standard_number_notes'];
	let codexStdYear =  foodAnswers.answerKeyValues['codex_standard_number_year'];
	let fdaStdSourceRef = foodAnswers.answerKeyValues['fda_standard_of_identity_sources'];
	let fdaStdNotes = foodAnswers.answerKeyValues['fda_standard_of_identity_notes'];
	let fdaStdYear = foodAnswers.answerKeyValues['fda_standard_of_identity_year'];
	let usdaSourceRef = foodAnswers.answerKeyValues['us_grades_usda_or_others__sources'];
	let usdaYear = foodAnswers.answerKeyValues['us_grades_usda_or_others__year'];
	let usdaNotes = foodAnswers.answerKeyValues['us_grades_usda_or_others__notes'];
	
	return (
		<div className="question-grouping" id="standards_and_grades">
			<h2>Standards and Grades</h2>
			<h3>
				CODEX Standards
				{codexStdYear ? 
				<small>&nbsp;({codexStdYear})</small>
				:""}
				{codexStdSourceRef && codexStdSourceRef > 0 ? 
				<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+codexStdSourceRef}>{codexStdSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['codex_standard_number']}</p>
			{codexStdNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{codexStdNotes}</em>
				</p>
			: ""}
			
			<h3>
				FDA Standard of Identity
				{fdaStdYear ? 
				<small>&nbsp;({fdaStdYear})</small>
				:""}
				{fdaStdSourceRef && fdaStdSourceRef > 0 ? 
				<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+fdaStdSourceRef}>{fdaStdSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['fda_standard_of_identity']}</p>
			{fdaStdNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{fdaStdNotes}</em>
				</p>
			: ""}
			
			<h3>
				USDA Grades
				{usdaYear ? 
				<small>&nbsp;({usdaYear})</small>
				: ""}
				{usdaSourceRef && usdaSourceRef > 0 ? 
				<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+usdaSourceRef}>{usdaSourceRef}</a></small>
				: ""}
			</h3>
			<p>{foodAnswers.answerKeyValues['us_grades_usda_or_others_']}</p>
			{usdaNotes  ? 
			<p className="notes-info" style={{marginTop: "auto"}}>
			<em>{usdaNotes}</em>
			</p>
			: ""}

		</div>
	);
	
}
export default StandardsGrades;